import type { DialogContentNode } from '@/v2/framework/dialog/types'
import { getSupplementalsByEntity } from '@/services/supplementals'

type TournamentTranslationRow = {
  name?: string | null
  info?: string | null
  supplementalNames?: { supplementalNameTypeId: string; name?: string | null }[]
}

export const buildTournamentTranslationFields = () => {
  const nodes: DialogContentNode[] = [
    {
      type: 'text-field',
      name: 'name',
      label: 'table_columns.name',
      placeholder: 'Enter name',
    },
    {
      type: 'text-field',
      name: 'info',
      label: 'table_columns.info',
      placeholder: 'Enter info',
    },
  ]

  const supplementalNameTypes = getSupplementalsByEntity('TOURNAMENT')
  for (const supplementalNameType of supplementalNameTypes) {
    nodes.push({
      type: 'text-field',
      name: `supplementalName_${supplementalNameType.id}`,
      label: `table_columns.${supplementalNameType.name.toLowerCase()}`,
      placeholder: 'Enter name',
      valueFormatter: (row: unknown) => {
        const r = row as TournamentTranslationRow
        return (
          r.supplementalNames?.find(
            (s) => String(s.supplementalNameTypeId) === String(supplementalNameType.id),
          )?.name ?? ''
        )
      },
    })
  }

  return nodes
}
